import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import * as userActions from './actions';
import * as usersApi from './api';
import ToastMessages from './components/ToastMessages';
import { toastify } from './../../components/shared/Toasts';

export function* savePreferences(action) {
    const { value: preferences } = action;

    try {
        yield call(usersApi.savePreferences, preferences);
        yield put(userActions.updatePreferences(preferences));
        yield toastify.success(ToastMessages.preferenceSaveSuccessMessage);
    } catch (e) {
        yield put(userActions.savePreferencesFail(preferences, e));
        yield toastify.error(ToastMessages.preferenceSaveErrorMessage);
    }
}

export function* doNotSetPreference(action) {
    const { value: preferences } = action;
    try {
        yield call(usersApi.savePreferences, preferences);
        yield put(userActions.updatePreferences(preferences));
    } catch (e) {
        yield put(userActions.savePreferencesFail(preferences, e));
        yield toastify.error(ToastMessages.preferenceSaveErrorMessage);
    }
}

export function* removePreferences(action) {
    const { value: id } = action;
    try {
        yield call(usersApi.deletePreferences, {id});
    } catch (e) {
        yield toastify.error(ToastMessages.preferenceSaveErrorMessage);
    }
}

export function* watchForSavePreferences() {
    yield takeEvery(userActions.SAVE_PREFERENCES, savePreferences);
    yield takeEvery(userActions.DO_NOT_SET_PREFERENCE, doNotSetPreference);
    yield takeEvery(userActions.REMOVE_PREFERENCES, removePreferences);
}

export default function* root() {
    yield all([fork(watchForSavePreferences)]);
}
